import { calculateFees } from '../../utilities/helpers'

const toNum = (value) => {
  const parsed = Number.parseFloat(value)
  return Number.isFinite(parsed) ? parsed : null
}

/**
 * Same numbers as Edit offer > Pricing & Fees > Ticket breakdown.
 * Stored price-level fees win when they are present. Otherwise the result
 * comes from calculateFees, which is what the breakdown panel uses.
 */
export function resolveTicketBreakdown(level, feeStructure, taxRates, event) {
  const calculated = calculateFees(level, feeStructure, taxRates, event) || {}

  const ticketFacilityFee =
    toNum(level?.ticketFacilityFee) ?? toNum(level?.fee) ?? 0
  const serviceFee =
    toNum(level?.serviceFee) ??
    toNum(level?.serviceFees) ??
    toNum(calculated?.serviceFee) ??
    toNum(calculated?.serviceFees) ??
    0
  const processingFee =
    toNum(calculated?.paymentProcessingFee) ??
    toNum(level?.paymentProcessingFee) ??
    0
  const salesTax =
    toNum(level?.salesTax) ??
    toNum(level?.taxPerTicket) ??
    toNum(calculated?.salesTax) ??
    toNum(calculated?.taxPerTicket) ??
    0
  const chargeBackProtection =
    toNum(level?.chargeBackProtection) ??
    toNum(calculated?.chargeBackProtection) ??
    0
  const ticketPrice = toNum(level?.offerPrice) ?? 0
  const payoutFallback = ticketPrice + ticketFacilityFee
  const payout =
    toNum(level?.payout) ?? toNum(calculated?.payout) ?? payoutFallback
  const totalToBuyer =
    ticketPrice +
    serviceFee +
    ticketFacilityFee +
    processingFee +
    salesTax +
    chargeBackProtection

  return {
    ...calculated,
    ticketPrice,
    basePrice: toNum(level?.basePrice) ?? 0,
    serviceFee,
    serviceFees: serviceFee,
    ticketFacilityFee,
    facilityFee: ticketFacilityFee,
    paymentProcessingFee: processingFee,
    processingFee,
    salesTax,
    chargeBackProtection,
    totalDue: toNum(level?.totalDue) ?? toNum(calculated?.totalDue) ?? 0,
    payout,
    totalToBuyer,
  }
}
